import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=0a9721a3&scoped=true&"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9721a3",
  null
  
)

export default component.exports